module.exports = __webpack_public_path__ + "img/thanhlong2.1afb8d61.jpeg";